export default {
  'areas.title': 'Gestionar Areas',
  'areas.form.id': 'ID',
  'areas.form.enable': 'Habilitar',
  'areas.form.name': 'Nombre',
  'areas.form.description': 'Descripción',
  'areas.form.statusLabel': '¿Elemento Habilitado?',
  'areas.enabled': 'Habilitado',
  'areas.disabled': 'Deshabilitado',
  'areas.title.import': 'Importar Areas',
};
